/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

export type EmailArchiveBrowseControllerListEmailsIntent =
  (typeof EmailArchiveBrowseControllerListEmailsIntent)[keyof typeof EmailArchiveBrowseControllerListEmailsIntent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailArchiveBrowseControllerListEmailsIntent = {
  promo: 'promo',
  flash_sale: 'flash_sale',
  product_launch: 'product_launch',
  newsletter: 'newsletter',
  welcome: 'welcome',
  abandoned_cart: 'abandoned_cart',
  back_in_stock: 'back_in_stock',
  transactional: 'transactional',
  seasonal: 'seasonal',
  other: 'other',
} as const;
